import React, { useState } from "react";
import "./index.scss";
import newsletter from "../../assets/newsletter.png";
import NewslettreService from "../../services/newsletter/newslettre.service";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { showErrorToaster } from "../toaster/error";
import { showSuccessToaster } from "../toaster/success";
const newslettreService = new NewslettreService();
const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  // Fonction de notification d'erreur

  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Vérification de l'email
    if (!email) {
      setEmailError("Le champ email est obligatoire.");
      showErrorToaster("Le champ email est obligatoire.");
    } else if (!isValidEmail(email)) {
      setEmailError("Veuillez entrer un email valide.");
      showErrorToaster("Veuillez entrer un email valide.");
    } else {
      try {
        // Préparer les données à envoyer
        const data = { email };

        // Appeler la méthode du service pour ajouter la formation
        await newslettreService.addNewslettre(data);

        // Afficher le toast de succès
        showSuccessToaster("Inscription réussie à la newsletter");

        // Réinitialiser le champ et l'erreur
        setEmail("");
        setEmailError("");
      } catch (error) {
        // Afficher le toast d'erreur
        showErrorToaster(
          error.response
            ? error.response.data.message
            : "Une erreur est survenue, veuillez réessayer."
        );
      }
    }
  };
  return (
    <section className="newsletter">
      <div className="newsletter-card">
        <div className="newsletter-left">
          <h2>Abonnez-vous à notre Newsletter</h2>

          <div className="newsletter-form">
            <input
              value={email}
              onChange={handleEmailChange}
              type="email"
              placeholder="Email..."
              className="newsletter-input"
              required
            />
            <button className="newsletter-btn" onClick={handleSubmit}>
              S'abonner
            </button>
          </div>
        </div>
        <div className="newsletter-right">
          <img src={newsletter} alt="Newsletter" className="newsletter-image" />
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
